import type { DirectoryPermissionEntry } from './types';

export function filterPermissionEntries(
  entries: DirectoryPermissionEntry[],
  searchTerm: string
): DirectoryPermissionEntry[] {
  const term = searchTerm.trim().toLowerCase();
  if (!term) {
    return entries;
  }
  return entries.filter((entry) => entry.name.toLowerCase().includes(term));
}

export function sortPermissionEntries(
  entries: DirectoryPermissionEntry[],
  ascending: boolean
): DirectoryPermissionEntry[] {
  return [...entries].sort((a, b) => {
    const comparison = a.name.localeCompare(b.name, 'pt-BR');
    return ascending ? comparison : -comparison;
  });
}

export function countAllowedEntries(entries: DirectoryPermissionEntry[]): number {
  return entries.filter((entry) => entry.allowed).length;
}

export function formatSelectedCount(count: number): string {
  return count.toString();
}
